import React from "react";
import { Link } from "react-router-dom";

const ThankYouPage = () => {
  return (
    <div className="min-h-[60vh] mt-[125px] flex flex-col items-center justify-center text-center px-4 text-primary">
      
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold pb-10">
        Thank you for getting in touch with Dee Delicious!
      </h1>

      <h3 className="text-2xl md:text-3xl pb-3">
        Your submission has been received.
      </h3>

      <h4 className="text-xl md:text-2xl">
        You'll be contacted soon.
      </h4>

      <div className="mt-6">
        <Link
          to="/"
          className="text-xl md:text-2xl underline text-secondary hover:text-[#4e8db7] transition-colors"
        >
          Return to Home
        </Link>
      </div>

    </div>
  );
};

export default ThankYouPage;